<template>
    <div class="page container" data-page="members">

        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link to="/members">Members</router-link>
        </div>
        
        <h1 class="title">All Members</h1>

        <!-- <div class="leaderboardBanner">
            <ion-icon name="trophy"></ion-icon>
            <h3>Leaderboard</h3>
            <p>Join events, collect points &amp; Get a gift.</p>
            <router-link to="/leaderboard" class="btn green">View Leaderboard</router-link>
        </div> -->

        <nav class="nav center mBottom">
            <a
                href="#0"
                @click.prevent="tab = 'Members'"
                :class="{active: tab === 'Members'}"
            >Members</a>
            <a
                href="#0"
                @click.prevent="tab = 'Users'"
                :class="{active: tab === 'Users'}"
            >Users</a>
        </nav>

        <!-- <div class="searchArea">
            <input v-model="searchInput" type="text" placeholder="Search" />
        </div> -->
        
        <MembersList v-show="tab === 'Members'" type="latest" grid="4"></MembersList>
        <MembersList v-show="tab === 'Users'" type="latestUsers" grid="4"></MembersList>

        <Membership></Membership>
    </div>
</template>

<script>
    import MembersList from '../components/MembersList.vue'
    import Membership from '../components/Membership.vue'

    export default {
        components: {
            MembersList,
            Membership
        },

        data(){
            return{
                tab: 'Members'
            }
        }  
    }
</script>


// WEBPACK FOOTER //
// src/views/Members.vue